import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ILoginByCode, ILoginByCodeResp } from '../_models/loginByCode';

@Injectable({
  providedIn: 'root',
})
export class AuthUploadUserService {
  constructor(private http: HttpClient) {}

  checkCode(model: ILoginByCode): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}CheckCode`, model);
  }

  loginByCode(model: ILoginByCode): Observable<ILoginByCodeResp> {
    return this.http.post<ILoginByCodeResp>(`${environment.apiUrl}LoginByCode`, model);
  }
}
